import Template from './Show.hbs';
import ActivitySlot from 'views/pages/sections/show/activitySlot/ActivitySlot';
import HeroButton from 'views/components/heroButton/HeroButton';
import VisibilityModal from 'views/components/modals/setVisibility/SetVisibility';
import Button from 'views/components/button/Button'
import PaginationNavigation from 'views/components/paginationNavigation/PaginationNavigation';
import ActivitiesCollection from 'collections/ActivitiesCollection';
import {createContentDomainFilterHeroDropdown} from 'views/components/contentDomainDropdown/ContentDomainDropdown'
import ExemptionLabelHeader from 'views/pages/sections/show/ExemptionLabelHeader.svelte'

export default class Show extends BaseView {

    initialize({ params }) {

        _.bindAll(
            this,
            'onClickAddActivity',
            'onLoadActivitiesInSection',
            'onReloadPage',
            'addPagination'
        );

        this.sectionModel = Backbone.Collection.sections.get(params[0]);

        Backbone.View.header.clearButtons()
        Backbone.View.header.setTitle(this.sectionModel.getPageTitle('show'))
        Backbone.View.header.setCrumblepath(
            this.sectionModel.getAllCrumblepathModels(),
            'show'
        )

        this.setElement(Template({}))

        if (ACL.checkRole(ACL.roles.TEACHER)) {
            if (!Backbone.Model.user.get('exam_product')) {
                Backbone.View.header.addButton(
                    new HeroButton({
                        firstLine: window.i18n.gettext('Set visibility'),
                        icon: 'eye',
                        callback: () => {
                            Backbone.View.Components.modal.open(VisibilityModal, {
                                title: window.i18n.gettext('Set visibility'),
                                model: this.sectionModel,
                                activitiesCollection: this.activitiesCollection
                            })
                        }
                    })
                );
            }

            this.loadActivities()
        }

        if (ACL.checkRole(ACL.roles.STUDENT)) {
            const contentDomain = this.sectionModel.getContentDomain()
            if (contentDomain) {
                createContentDomainFilterHeroDropdown(
                    this.sectionModel,
                    (selectedContentDomainId) => this.loadActivities(selectedContentDomainId)
                )
            } else {
                this.loadActivities()
            }
        }
    }

    loadActivities(contentDomainId = null) {
        this.destroyChildViewsOfType(ActivitySlot)
        this.destroyChildViewsOfType(Button)
        this.destroyChildViewsOfType(PaginationNavigation)

        this.activitiesCollection = new SectionActivitiesCollection(null, {
            parse: true,
            sectionModel: this.sectionModel,
            contentDomainId,
        })
        this.activitiesCollection.fetch({
            success: this.onLoadActivitiesInSection,
        });

    }

    /**
     * openToolTipForSectionShow
     *
     * This functions opens a tour tool tip that points towards the first activity of a section
     * that is a linear activity with a measurable amount of progress, meaning that the
     * activity contains at least 1 task.
     */
    openToolTipForSectionShow() {

        const activityList = this.getChildViewsOfType(ActivitySlot);

        const linearActivity = _.find(
            activityList,
            (activityView) => activityView.model.get('type') === 'linear'
        );

        const activityWithProgress = _.find(
            activityList,
            (activityView) => {
                return activityView.model.get('type') === 'linear'
                    && activityView.model.get('progress') !== null
            }
        );

        // Preferer activity with progress above activity without progress
        if (activityWithProgress) {
            Backbone.View.layout.addTourTooltip({
                message: window.i18n.gettext('View tasks and sources'),
                target: activityWithProgress.$('.js-content-label > div')
            });

        // Else we just has to do with what we have
        } else if (linearActivity) {
            Backbone.View.layout.addTourTooltip({
                message: window.i18n.gettext('View tasks and sources'),
                target: linearActivity.$('.js-content-label > div')
            });
        }
    }

    onReloadPage() {
        Backbone.history.loadUrl(Backbone.history.fragment);
    }

    onClickAddActivity() {
        Backbone.history.navigate(
            // Escape slash at the end of the string in a template due to a bug in xgettext, the GNU tool for
            // generating the translation file used by Poedit. https://gitlab.gnome.org/GNOME/gnome-shell/issues/537#note_309678
            `/sections/author/${this.sectionModel.id}${'/'}action:add_activity`,
            {trigger: true}
        );
    }

    onLoadActivitiesInSection() {

        if (this.activitiesCollection.hasExemption) {
            Backbone.View.header.setTitle(
                {
                    view: ExemptionLabelHeader,
                    props: {
                        title: this.sectionModel.getPageTitle('show'),
                    }
                }
            )
        }

        if (this.activitiesCollection.length > 0) {

            // update global activities collection
            Backbone.Collection.activities.push(this.activitiesCollection.models, {silent: true})

            this.activitiesCollection.forEach((activity) => {

                this.addChildView(
                    new ActivitySlot({ model: activity }),
                    activity.get('type') === 'adaptive_student'
                        // If type is adaptive student, append it to the practice container, which
                        // will be below the linear activities container
                        ? '.js-practice-activities-holder'

                        // When not of the adaptive type
                        // Append it to the normal activity holder
                        : '.js-activities-holder'
                );

            });

            // Hide the empty state that could be visible
            this.$('.js-no-activities').hide();

        } else {

            // If there are no activities, show an empty state with reload button
            this.addChildView(new Button({
                label: window.i18n.gettext('Reload page'),
                callback: this.onReloadPage
            }), '.js-reload-page');
            this.$('.js-no-activities').show();

        }

        if (!ISMOBILE) {
            this.addPagination()
        }

        if (Backbone.Model.user.get('is_demo')) {
            this.openToolTipForSectionShow();
        }

    }

    show() {

        // Abort show if sectionModel is not defined.
        if (this.sectionModel === undefined) {
            return;
        }

        // If user is not mobile
        if (!ISMOBILE) {

            // Convert is_teach to Boolean and check if true
            if (Backbone.Model.user.get('is_teacher')) {
                Backbone.View.Components.actionbutton.switchIcon('add');
                Backbone.View.Components.actionbutton.persistantCallback = true;
                Backbone.View.Components.actionbutton.show(
                    this.onClickAddActivity,
                    window.i18n.gettext('Add activity')
                );
            }
        }

        Backbone.View.header.setBackgroundImage(this.sectionModel)
    }

    hide(callback) {
        if (Backbone.Model.user.get('is_teacher')) {
            Backbone.View.Components.actionbutton.hide();
        }
        callback(this)
    }

    // Add buttons to navigate to previous and next section
    addPagination() {

        // Find the next and previous section (if available)
        const current = Backbone.Collection.sections.indexOf(this.sectionModel)
        const previousSection = Backbone.Collection.sections.at(current - 1)
        const nextSection = Backbone.Collection.sections.at(current + 1)
        let previousUrlOrCallback, previousLabel, nextUrlOrCallback, nextLabel

        // note: Backbone.Collection.at(), if given a negative index, retrieves a model from
        // the back of the collection. prevent showing the last model of the collection when
        // index of the current model is 0 (or lower)
        if (
            previousSection &&
            previousSection.getGroupModel()?.id === this.sectionModel.getGroupModel()?.id &&
            current > 0
        ) {
            previousUrlOrCallback = '/sections/show/' + previousSection.id
            previousLabel = previousSection.getLabel().title
        }
        if (nextSection && nextSection.getGroupModel()?.id === this.sectionModel.getGroupModel()?.id) {
            nextUrlOrCallback = '/sections/show/' + nextSection.id
            nextLabel = nextSection.getLabel().title
        }

        // Add pagination to the page
        this.addChildView(
            new PaginationNavigation({
                previousUrlOrCallback,
                previousLabel,
                nextUrlOrCallback,
                nextLabel,
            }),
            '.js-pagination'
        )
    }

    onDestroy() {
        Backbone.View.header?.removeBackgroundImage()
    }

}

class SectionActivitiesCollection extends ActivitiesCollection {

    get url() {
        // TODO remove the new_version parameter from URL when backend has been updated.
        // See https://linear.app/dedact/issue/LBTT-1276/verwijder-legacy-response-format-sectionsget-activities
        if (Number.isInteger(this.selectedContentDomainId)) {
            return `/sections/get_activities/${this.sectionModel.id}.json?content_domain_item_id=${this.contentDomainId}&new_version=true`
        }
        return `/sections/get_activities/${this.sectionModel.id}.json?new_version=true`
    }

    initialize(
        attr,
        {
            sectionModel,
            selectedContentDomainId,
        }
    ) {
        this.sectionModel = sectionModel
        this.selectedContentDomainId = selectedContentDomainId
    }

    parse(response) {
        this.hasExemption = response.hasExemption
        return response.activities.filter((activity) => {
            return !!ACL.isAllowed(
                ACL.resources.ACTIVITIES,
                ACL.actions.VIEW,
                { type: activity.type }
            )
        })
    }

}
